"use strict";
/*global PRODUCTION*/
/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
require("hammerjs");
var core_1 = require("@angular/core");
var platform_browser_dynamic_1 = require("@angular/platform-browser-dynamic");
var app_module_1 = require("./app/app.module");
require("./main.scss");
var Config_1 = require("Config");
if (Config_1.environment.production) {
    core_1.enableProdMode();
}
platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule)
    .catch(function (err) {
    if (!Config_1.environment.production) {
        console.log(err);
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFpbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm1haW4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLHFCQUFxQjtBQUNyQjs7OztHQUlHOztBQUVILG9CQUFrQjtBQUNsQixzQ0FBK0M7QUFDL0MsOEVBQTJFO0FBRTNFLCtDQUE2QztBQUU3Qyx1QkFBcUI7QUFDckIsaUNBQXFDO0FBRXJDLElBQUksb0JBQVcsQ0FBQyxVQUFVLEVBQUU7SUFDeEIscUJBQWMsRUFBRSxDQUFDO0NBQ3BCO0FBRUQsaURBQXNCLEVBQUUsQ0FBQyxlQUFlLENBQUMsc0JBQVMsQ0FBQztLQUM5QyxLQUFLLENBQUMsVUFBQSxHQUFHO0lBQ04sSUFBSSxDQUFDLG9CQUFXLENBQUMsVUFBVSxFQUFFO1FBQ3pCLE9BQU8sQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUM7S0FDcEI7QUFDTCxDQUFDLENBQUMsQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./src/main.ts
// module id = 1213
// module chunks = 0